import React, { Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import PageText from 'components/base/page-text';
import useDashboardContext from 'contexts/dashboard.context';

const CokitchenContent = () => {
  const { activeCokitchen } = useDashboardContext();
  return (
    <Fragment>
      {activeCokitchen.id ? <Outlet /> : <PageText text='Loading kitchen data...' />}
    </Fragment>
  );
};

export default CokitchenContent;
